<template>
  <div ref="topDom">
    <a-tabs
        v-model:activeKey="searchForm.status"
        style="background-color: #fff; padding: 0 12px"
        @change="getTableData()"
    >
      <a-tab-pane key="0" tab="全部"></a-tab-pane>
      <a-tab-pane key="1" tab="待处理"></a-tab-pane>
      <a-tab-pane key="2" tab="处理中"></a-tab-pane>
      <a-tab-pane key="3" tab="已处理"></a-tab-pane>
    </a-tabs>
  </div>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 10 ? 2500 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'operate'">
          <a-button
              v-if="
              record.refund_status == 0 &&
              record.status != 5 &&
              record.status != 4
            "
              class="f-c-red"
              type="link"
              @click="cancel(record)"
          >取消
          </a-button
          >
          <a-button
              v-if="record.status == 2"
              type="link"
              @click="updateStatus(record)"
          >去处理
          </a-button
          >
          <a-button
              v-if="record.status == 3"
              type="link"
              @click="updateStatus(record)"
          >已处理
          </a-button
          >
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />

    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import {createVNode, onMounted, reactive, toRefs, watch} from "vue";
import {OrderServiceCancel, OrderServiceList, OrderServiceUpdateStatus,} from "@/api/api";
// import dayjs from "dayjs";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import {message, Modal} from "ant-design-vue";
import store from "@/store/pms/landlord/index";

export default {
  components: {
    OrderDetails,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        start: 0,
        limit: 20,
        status: 0,
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      // 取消
      cancel(item) {
        Modal.confirm({
          title: "是否取消?",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            OrderServiceCancel({
              applyId: item.id,
            }).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      // 修改状态
      updateStatus(item) {
        let status = "";
        let texts = "";
        if (item.status == 2) {
          status = 3;
          texts = "是否进行处理?";
        } else if (item.status == 3) {
          status = 4;
          texts = "是否已处理?";
        }
        Modal.confirm({
          title: texts,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            OrderServiceUpdateStatus({
              applyId: item.id,
              status,
            }).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        OrderServiceList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          isShow: true,
        },
        {
          title: "房号",
          dataIndex: "orderName",
          key: "orderName",
          isShow: true,
        },
        {
          title: "客房服务",
          dataIndex: "name",
          key: "name",
          isShow: true,
        },
        {
          title: "金额（元）",
          dataIndex: "amount",
          key: "amount",
          isShow: true,
        },
        {
          title: "申请时间",
          dataIndex: "create_time",
          key: "create_time",
          isShow: true,
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          customRender: ({record}) => {
            if (record.status == 1) {
              return "待支付";
            } else if (record.status == 2) {
              return "待处理";
            } else if (record.status == 3) {
              return "处理中";
            } else if (record.status == 4) {
              return "已处理";
            } else {
              return "已取消";
            }
          },
          isShow: true,
        },
        {
          title: "",
          dataIndex: "operate",
          key: "operate",
        },
      ],
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableList();
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 15;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 15;
      console.log(table.tableHeight);
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
